import React from 'react';
interface OperationsCardProps {
  title: string;
  description: string;
  icon?: string;
}
export const OperationsCard: React.FC<OperationsCardProps> = ({
  title,
  description,
  icon
}) => {
  return <div className="flex flex-col items-start text-left" data-id="element-141" data-mp="3idvd6qckd2z5">
      {icon && <div className="mb-6" data-id="element-142" data-mp="3edbevjg97tbf">
          <img src={icon} alt={title} className="w-16 h-16 md:w-20 md:h-20" data-id="element-143" data-mp="3ee2yrx0ho2lv" />
        </div>}
      <h3 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-144" data-mp="ewvbq8d63qkd">
        {title}
      </h3>
      <p className="font-inter text-base leading-relaxed text-black" data-id="element-145" data-mp="a04uhhpmmoxd">
        {description}
      </p>
    </div>;
};